import styled, { css } from "styled-components";
import { FieldGrid, WideField } from "../../../styles";

export const NewPermissionArea = styled(FieldGrid)``;

export const UserGroupArea = styled(WideField)``;

export const CheckBoxManadatory = styled.div`
	flex-grow: 0 !important;
	flex-basis: 0;
`;

export const AreaButton = styled.div`
	margin-top: 1rem;
	> button {
		margin-left: 0px;
		margin-right: 1rem;
	}
`;

interface IContainerCopmanySelectProps {
	$isNullUndefinedValue: boolean;
}
export const ContainerCopmanySelect = styled.div<IContainerCopmanySelectProps>`
	position: relative;
	width: 100%;

	${({ $isNullUndefinedValue }) =>
		$isNullUndefinedValue &&
		css`
			.MuiInputBase-root.MuiInputBase-formControl {
				padding-right: 140px !important;
			}
			.ClearableIcon {
				display: none;
				color: ${({ theme }) => theme.pantone2726C};
			}

			&:hover {
				.ClearableIcon {
					display: block;
				}
			}
		`}
`;

export const AreaCheckboxAllCopmanies = styled.div`
	position: absolute;
	display: flex;
	top: 12px;
	right: 40px;
	margin: 0;
	justify-content: center;
	align-items: center;

	.MuiFormControlLabel-root {
		margin: 0;
	}

	.MuiCheckbox-root {
		padding: 0;
	}

	.MuiCheckbox-colorSecondary.Mui-checked {
		color: #fab01c;
	}
`;
